import React, { useState, useEffect } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";

import MoveToInboxSharpIcon from "@mui/icons-material/MoveToInboxSharp";
import HistorySharpIcon from "@mui/icons-material/HistorySharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import ReplaySharpIcon from '@mui/icons-material/ReplaySharp';
import { Link } from "react-router-dom";
import { ShimmerDiv } from "shimmer-effects-react";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import error from "../../assets/images/Not-Found.png";
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";




function AppliedSec(props) {
	const sessionId = localStorage.getItem("sessionId");
	const UserType = localStorage.getItem("userType");
	// const [isLoading, setIsLoading] = useState(true);

	const [page, setPage] = useState(0);
	const [Appliedjob, setAppliedjob] = useState([]);
	const [isError, setIsError] = useState(false);
	const [isErrorInscan, setIsErrorInscan] = useState(false);

	const [isLoading, setIsLoading] = useState(true);
	const [totalRows, setTotalRows] = useState(1);
	const [groupTotalRows, setGroupTotalRows] = useState(1);
	const [currentPage, setCurrentPage] = useState(1);
	const [groupClassName, setGroupClassName] = useState("");

	//  // ........................................Job info start..........................

	const [jobInfo, setJobInfo] = useState("");
	console.log("jobInfo", jobInfo);


	const [showInfoModal, setShowInfoModal] = useState(false);
	const handleInfoShow = () => setShowInfoModal(true);
	const handleCloseInfoModal = () => setShowInfoModal(false);

	const JobInfoDate = async (id) => {
		const data = {
			sessionId: sessionId,
			jbApplctnId: id,
		};
		console.log("data22", data);
		try {
			await axios.post("/JobApplication/GetInfo", data).then((resData) => {
				console.log("Info job", resData.data.responseData);
				const data = resData.data.responseData;
				setJobInfo(data);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
				console.log("Unapply ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};

	//  // ........................................Job info End..........................

	//  // ........................................Job info End..........................
	const [interviewDetail, setinterviewDetail] = useState("");
	const [interviewDetailModal, setinterviewDetailModal] = useState(false);
	const handleinterviewDetail = (row) => {
		setinterviewDetail(row); // Ensure `groupInfo` gets updated
		setinterviewDetailModal(true);
	};
	const handleCloseinterviewDetail = () => setinterviewDetailModal(false);

	console.log("interviewDetail", interviewDetail);

	//  // ........................................Job info End..........................

	// ........................................Job History start..........................

	const [jobHistory, setJobHistory] = useState("");
	const [showHistoryModal, setShowHistoryModal] = useState(false);
	const handleHistoryShow = () => setShowHistoryModal(true);
	const handleCloseHistoryModal = () => setShowHistoryModal(false);

	const JobHistory = async (id) => {
		const data = {
			sessionId: sessionId,
			jbApplctnId: id,
		};
		console.log("data22", data);
		try {
			await axios.post("/JobApplication/GetHistory", data).then((resData) => {
				console.log("HISTORY", resData.data.responseData);
				const data = resData.data.responseData;
				setJobHistory(data);
			});
		} catch (e) {
			console.log("Unapply ");
		}
	};
	console.log("Appliedjob", Appliedjob);

	// ........................................Job History End..........................

	// ........................................Job History start..........................

	const [candidateId, setCandidateId] = useState(null);
	const [hiringStatuses, setHiringStatuses] = useState({});
	const [hiringStatusvalue, setHiringStatusvalue] = useState({});
	const [candData, setCandData] = useState("");
	const [search, setSearch] = useState("");

	const [groupInfo, setgroupInfo] = useState([]);
	const [jobAppId, setJobAppId] = useState(null);
	const [groupCurrentPage, setGroupCurrentPage] = useState(1)

	const [showgroupInfoModal, setShowgroupInfoModal] = useState(false);
	const handlegroupInfoShow = (id) => {
		setShowgroupInfoModal(true);
		// setgroupInfo([]);
		//GetgroupInfo(id);
		setJobAppId(id)
	};
	const handleClosegroupInfoModal = () => {
		setShowgroupInfoModal(false);
		// setgroupInfo([]);
	};


	const GetgroupInfo = async (id, page) => {
		setIsLoading(true);
		setGroupCurrentPage(page)
		const data = {
			sessionId: sessionId,
			jbApplctnId: id,
			pageNumber: page,
			pageSize: 10,
		};
		try {
			await axios.post(`/JobApplication/GetInstituteCandidateHiringStatusList?Search=${search.toLocaleLowerCase()}`, data).then((resData) => {
				console.log("HISTORY", resData.data.responseData);
				const data = resData.data.responseData.items;
				const data1 = resData.data.responseData
				console.log("data=====>", data);
				setgroupInfo(data1?.items || []);
				setGroupTotalRows(resData.data.responseData?.paging?.allDataCount || 0);
				if (data.length > 0 && data[0].insttCandidateProfile?.insttClssName) {
					setGroupClassName(data[0].insttCandidateProfile.insttClssName);
				}
				setIsLoading(false);
				setIsErrorInscan(false);

			});
		} catch (e) {
			setIsErrorInscan(true);
			console.log("Unapply ");
		}
	};

	// ........................................Job History End..........................

	// ...............................All Job List Start.......................................
	const userUID = localStorage.getItem("userUID");

	const [unAuthorizeError, setUnAuthorizeError] = useState("");

	const [unauthModal, setUnauthModal] = useState(false);
	const handleunauthModal = () => setUnauthModal(true);
	const handlecloseunauthModal = () => setUnauthModal(false);


	const getAppliedJobList = async (page) => {
		console.log("Page===>", page)
		setCurrentPage(page);
		try {
			const data = {
				sessionId: sessionId,
				pageNumber: page,
				pageSize: 10,
			};
			axios
				.post(`/Job/GetAppliedJobs`, data)
				.then((response) => {
					const res = response?.data?.responseData || {};
					setAppliedjob(res?.aplliedJobsList || []);
					setTotalRows(res?.paging?.allDataCount || 0);

					setIsError(res.length === 0); // If no jobs, set error state
					setIsLoading(false);
				})
				.catch((err) => {
					console.error("Error fetching jobs:", err);
					setIsError(true); // Handle error state
					setIsLoading(false);
					if (err.response && err.response.status === 409) {
						// toast.error(err.response.data.message);
						console.error("Unexpected error:", err);
						setUnAuthorizeError(err.response.data.message)
						handleunauthModal()
					} else {
						console.error("Unexpected error:", err);

					}
				});
		} catch (e) {
			console.error("Error fetching applied jobs:", e);
			if (e.response && e.response.status === 404) {
				setIsError(true);
			}
		}
	};

	useEffect((id) => {
		getAppliedJobList(1);
		// if (jobAppId) {
		// 	GetgroupInfo(jobAppId);
		GetgroupInfo(jobAppId, 1);
		// }
	}, [search]);



	//  ........................ job details modal ...............................
	const [selectedJob, setSelectedJob] = useState(null);
	const [showJobDetailModal, setShowJobDetailModal] = useState(false);

	const handleJobClick = (job) => {
		setSelectedJob(job);
		setShowJobDetailModal(true);
	};

	const handleCloseJobDetailModal = () => {
		setShowJobDetailModal(false);
		setSelectedJob(null);
	};
	// ...............................All Jobs List End.......................................
	// ................................UnapplyJob Start....................

	const [jobId, setjobId] = useState("");
	const [showAppliedModal, setShowAppliedModal] = useState(false);
	const handleShow = () => setShowAppliedModal(true);
	const handleCloseModal = () => setShowAppliedModal(false);

	const UnapplyJobCandidate = async () => {
		const data = {
			sessionId: sessionId,
			jobId: jobId,
		};

		try {
			await axios.post("/JobAction/UnApplyJobAsCnddt", data).then((resData) => {
				console.log("Unapply job", resData.data.message);
				toast.success(resData.data.message);
				setAppliedjob((prev) => prev.filter((item) => item.jobId !== jobId));
				getAppliedJobList();
				setShowAppliedModal(false);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
				console.log("Unapply ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	const [jobGroupId, setjobGroupId] = useState("")
	const UnapplyJobInstitute = async () => {
		const data = {
			sessionId: sessionId,
			jobId: jobId,
			icsid: jobInfo.grpTypName === 'Class' ? jobInfo.grpTypeId : null,
			icbid: jobInfo.grpTypName === 'Batch' ? jobInfo.grpTypeId : null,
		};
		console.log("data", data);

		try {
			await axios.post("/JobAction/UnApplyJobAsInstt", data).then((resData) => {
				console.log("Unapply job", resData);
				toast.success(resData.data.message);
				setAppliedjob((prev) => prev.filter((item) => item.jobId !== jobId));
				getAppliedJobList();
				setShowAppliedModal(false);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
				console.log("Unapply ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	// ........................................UnapplyJob End..........................

	const columns = [
		{
			name: "Job Details",
			center: true,
			sortable: true,
			minWidth: "200px",
			cell: (row) => (
				<div
					className="text-center mt-3 mb-3"
					style={{ display: "flex", flexDirection: "column", gap: "5px" }}
				>
					<div>
						<div className="pointer jobinfo f-600 " style={{ color: "rgb(13 110 253)" }}
							onClick={() => {
								handleJobClick(row)
							}}>
							{row.title}
						</div>
					</div>
					<div className="">
						{row.cityName}
					</div>
					<div className="">
						{moment.utc(row.creationTime).local().format("DD MMM YYYY, hh:mm A")}
					</div>

				</div>
			),
		},
		{
			name: "Company Name",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => (
				<div className="Applied Comp f-600" >
					{row.compType === "Company" ? (
						<Link to={`/Company/${row.compUid}`} >
							<div style={{ color: "rgb(13 110 253)" }}>

								{row.compName}
							</div>
						</Link>
					) : (

						<Link to={`/Recruiter/${row.compUid}`}>
							<div style={{ color: "rgb(13 110 253)" }}>

								{row.compName}
							</div>
						</Link>
					)}

				</div>
			)
		},
		{
			name: "Designation",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.designationName,
		},
		{
			name: "Status",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => (
				<>
					<div className="job-foote p-3 text-center">
						<ul className="p-0">
							<li
								className={`badge ${row.hiringStatusName === "Hired" ? "badge-green" :
									row.hiringStatusName === "Applied" ? "badge-purple" :
										row.hiringStatusName === "Withdraw" ? "badge-red" :
											row.hiringStatusName === "Scheduled" ? "badge-yellow" :
												row.hiringStatusName === "Rejected" || row.hiringStatusName === "Blocked" ? "badge-red" : "badge-purple"
									}`}
							>
								{row.hiringStatusName}
								
							</li>
						
						</ul>
					</div>
					<div>
						<p className="text-center " style={{fontSize:"10px"}}>Applied Time: {moment.utc(row.appliedTime).local().format("DD MMM YYYY, hh:mm A")}</p>
					</div>
				</>
			),
		},

		{
			name: "Action",
			center: true,
			minWidth: "200px",
			cell: (row) => (
				<>
					{row.hiringStatusName !== "Withdraw" && row.hiringStatusName !== "Blocked" && row.hiringStatusName !== "Hired" && row.hiringStatusName !== "Rejected" ? (
						<span className="me-2">
							<Tooltip title="Withdraw" arrow>
								<ReplaySharpIcon
									className="pointer"
									style={{ color: "#eb4d4d" }}
									onClick={() => {
										handleShow();
										setjobId(row.jobId);
										JobHistory(row.jbApplctnId);
										JobInfoDate(row.jbApplctnId);
									}}
								/>
							</Tooltip>
						</span>
					) : null}

					{UserType === "Candidate" ? (
						<span className="me-2">
							<Tooltip title="History" arrow>
								<HistorySharpIcon
									onClick={() => {
										handleHistoryShow();
										JobHistory(row.jbApplctnId);
									}}
									className="pointer"
								/>
							</Tooltip>
						</span>

					) : (
						//  {UserType === "Institution" && (
						<span>
							<Tooltip title="Group Details" arrow>
								<PeopleSharpIcon
									onClick={() => {
										handlegroupInfoShow(row.jbApplctnId);
										GetgroupInfo(row.jbApplctnId, 1);

									}}
									className="pointer"
								/>
							</Tooltip>
						</span>
					)}

				</>
			),
		}

	];


	const Inscolumns = [
		{
			name: "CANDIDATES",
			// center: true,
			sortable: true,
			cell: (row) => (
				<div className="pt-2 pb-2" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div
						style={{ display: "flex", alignItems: "center", gap: "5px" }}
						className="inst-cacndidate-list-style " >
						<img
							src={row.profileImage}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>
						<div className="row">
							<div className=" ">{row.firstName}</div>
							<div className=" ">{row.lastName}</div>
						</div>
					</div>

				</div>
			),
		},
		{
			name: "CITY NAME",
			center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<div className="pointer">{row.cityName}</div>
					</div>
				</div>
			),
		},
		// {
		// 	name: "CLASS NAME",
		// 	center: true,
		// 	sortable: true,
		// 	// minWidth: "150px",
		// 	cell: (row) => (
		// 		<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
		// 			<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
		// 				<div className="pointer">{row.insttCandidateProfile.insttClssName}</div>
		// 			</div>
		// 		</div>
		// 	),
		// },
		{
			name: "BATCH NAME",
			center: true,
			sortable: true,
			// minWidth: "150px",
			selector: (row) =>
				Array.isArray(row.insttCandidateProfile.batchNames)
					? row.insttCandidateProfile.batchNames.join(", ")
					: row.insttCandidateProfile.batchNames,
		},
		{
			name: "STATUS",
			center: true,
			sortable: true,
			cell: (row) => {
				const statusValue = row.currentHiringStatus === null ? "Applied" : row.currentHiringStatus;
				const statusText = row.currentHiringStatus === null ? "Applied" : row.currentHiringStatus;

				let badgeClass = "green";
				if (statusValue === 1) {
					badgeClass = "default";
				} else if (statusValue === "Scheduled") {
					badgeClass = "orange";
				} else if (statusValue === "Rejected" || statusValue === "Blocked") {
					badgeClass = "red";
				}

				return (
					<>
						<div className={`job-footer-left ${badgeClass}`}>
							<ul style={{ margin: 0, padding: 0 }}>
								<li>
									{statusText}

									{statusValue === "Scheduled" && (
										<span className="me-2">
											<Tooltip title="History" arrow>
												<HistorySharpIcon
													onClick={() => {
														handleinterviewDetail(row);
														// JobHistory(row.jbApplctnId);
													}}
													className="pointer"
												/>
											</Tooltip>
										</span>
									)}
								</li>
							</ul>
						</div>


					</>

				);
			},
		},

	];

	const handlePageChange = (pageNumber) => {
		setPage(pageNumber - 1);
		getAppliedJobList(pageNumber - 1);
	};

	// .................................shortDescription
	const addTargetBlankToAnchors = (html) => {
		const div = document.createElement('div');
		div.innerHTML = html;

		const anchors = div.querySelectorAll('a');
		anchors.forEach(anchor => {
			anchor.setAttribute('target', '_blank');
			anchor.setAttribute('rel', 'noopener noreferrer');
		});

		return div.innerHTML;
	};


	const linkifyContent = (htmlContent) => {
		const urlPattern = /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
		return htmlContent.replace(urlPattern, function (url) {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	};
	// .................................shortDescription
	console.log("groupInfo", groupInfo.scheduledInterviewInfo?.scheduleTime);

	return (
		<>
			<section className="pricing-section-three container jobapplication Appliedjob application-drop-section">
				<div className="mt-2">
					<h6 className="orange-title">
						<span className="orange-box me-2"></span>
						{props.title}{" "}
					</h6>
				</div>
				<div className="container st3">
					<div className="row">

						<div className="col-lg-12">
							{isLoading ? (
								<div className="row mt-2">
									<div className="col-md-12">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
								</div>
							) : isError ? (
								<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
									<img src={error} alt="404 Not Found" width={300} />
									{/* <p class=" d-flex justify-content-center">There is no record to display</p> */}
								</div>
							)
								: Appliedjob.length === 0 ? (
									<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
										{/* <p class=" d-flex justify-content-center">There are no records to display.</p> */}
										<img src={error} alt="404 Not Found" width={300} />
									</div>
								)
									: (
										<div className="scroll-react-dataTable">

											<div className="react-dataTable react-table-colorclass">

												<DataTable
													noHeader
													pagination
													columns={columns}
													data={Appliedjob}
													progressPending={isLoading} // Show a loader when fetching data
													paginationServer // Enable server-side pagination
													paginationPerPage={10} // Number of rows per page
													paginationTotalRows={totalRows} // Total rows for calculating pages
													paginationRowsPerPageOptions={[]}
													paginationDefaultPage={currentPage}
													onChangePage={(page) => {
														getAppliedJobList(page); // Update the current page
													}}
													sortIcon={<ChevronDown size={10} />} // Sorting icon
													className="react-dataTable" // Custom class for styling
												/>

											</div>

										</div>
									)}
						</div>
					</div>
				</div>
			</section>

			{/*.................................... UnApply Job Modal Start ................................*/}

			<Modal show={showAppliedModal} onHide={handleCloseModal} centered>
				<Modal.Header>
					<Modal.Title> Unapply job</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to Unapply job</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button

						onClick={() => {
							if (UserType === "Candidate") {
								console.log("Test UserType==Candidate")
								UnapplyJobCandidate();
							} else {
								console.log("Test UserType==")
								UnapplyJobInstitute();
							}

						}}

						className="btn btn-danger me-2"
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>
			{/*.................................... UnApply Job Modal End ................................*/}

			{/*.................................... History Job Modal Start ................................*/}

			<Modal show={showHistoryModal} onHide={handleCloseHistoryModal} centered>
				<Modal.Header>
					<Modal.Title> Job history</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseHistoryModal}
					/>
				</Modal.Header>
				<Modal.Body className="settings" style={{ maxHeight: "400px", overflowY: "auto" }}>
					{jobHistory && jobHistory.length > 0 ? (
						jobHistory.map(
							(data, index) => (
								(
									<div
										className="profile-resume-user-acvtivity mt-4"
										key={index} >
										<div className="d-flex justify-content-between mb-2 align-center">
											<div className="d-flex align-items-center">
												<div
													className={`profile-resume-applied-status me-2 ${data.hiringStatus === 1 || data.hiringStatus === 9
														? "profile-resume-initial-icon"
														: data.hiringStatus === 5
															? "profile-resume-cv-icon"
															: data.hiringStatus === 4 || data.hiringStatus === 6
																? "profile-resume-success-icon"
																: ""
														}`}
												></div>
												<div className="profile-resume-applied-jobs f-16 f-700 ">
													Hiring Status : {data.hiringStatusName}
												</div>
											</div>
											<div className="profile-resume-user-activity-time f-14 f-400">
												<span className="f-600">
													{moment.utc(data.time)
														.local()
														.format("DD MMM YYYY -- hh : mm A")} </span>
											</div>
										</div>
										<div className="profile-resume-user-actvity-container mb-3">
											{data.remark === "" ? '' : (

												<p className="f-14 f-400 mb-1"><span className="f-600">Remark : </span> {data.remark}</p>
											)}
											{data.scheduledInterviewInfo === null ? '' : (
												<>
													<h6 className="f-600 mb-1"> <u>Interview Details</u> </h6>
													{data.scheduledInterviewInfo?.placeDetails === null ? '' : (
														<p className="f-14 f-400 mb-1">
															<span className="f-600">Location : </span>
															{data.scheduledInterviewInfo.placeDetails}
														</p>
													)}
													{data.scheduledInterviewInfo?.remark === null ? '' : (
														<p className="f-14 f-400 mb-1">
															<span className="f-600">Remark : </span>
															{data.scheduledInterviewInfo.remark}
														</p>
													)}
													{data.scheduledInterviewInfo?.placeType === null ? '' : (
														<p className="f-14 f-400 mb-1">
															<span className="f-600">Place Type : </span>
															{data.scheduledInterviewInfo.placeType}
														</p>
													)}
													{data.scheduledInterviewInfo?.scheduleTime && (
														<div className="profile-resume-pdf-text f-14 f-500 d-conntents">
															<CalendarMonthSharpIcon className="me-1" /> Date : {moment
																.utc(data.scheduledInterviewInfo.scheduleTime)
																.local()
																.format("DD MMM YYYY -- hh : mm A")}
														</div>
													)}
												</>

											)}
										</div>
									</div>
								)
							)
						)
					) : (
						<p>No job history available.</p>
					)}
				</Modal.Body>

			</Modal>
			{/*.................................... Group detail Modal End ................................*/}

			<Modal show={showgroupInfoModal}
				size="xl"
				onHide={handleClosegroupInfoModal}
				centered>
				<Modal.Header>
					<Modal.Title>Group details ({groupClassName})</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={() => {
							handleClosegroupInfoModal();
							setgroupInfo("");
						}}
					/>
				</Modal.Header>

				<Modal.Body className="settings jobapplication">
					<div className="container st3">
						<div className="row">
							<div className="col-lg-12">
								<div className="manage-search-bar">
									<SearchIcon className="icon" />
									<input
										type="text"
										placeholder="Search Candidates"
										className="manage-search-input Dark-Manage-Search"
										onChange={(e) => {
											setSearch(e.target.value);
											GetgroupInfo();
										}}
									/>
								</div>
								{isLoading ? (
									<div className="row mt-2">
										<div className="col-md-12">
											<ShimmerDiv mode="light" height={100} width={'100%'} />
										</div>
										<div className="col-md-12 mt-2">
											<ShimmerDiv mode="light" height={100} width={'100%'} />
										</div>
										<div className="col-md-12 mt-2">
											<ShimmerDiv mode="light" height={100} width={'100%'} />
										</div>
										<div className="col-md-12 mt-2">
											<ShimmerDiv mode="light" height={100} width={'100%'} />
										</div>
									</div>
								) : isErrorInscan ? (
									<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
										<img src={error} alt="404 Not Found" width={300} />
										{/* <p class=" d-flex justify-content-center">There is no record to display</p> */}
									</div>
								) : (
									<div className="table-res">
										<div className="react-dataTable  react-table-colorclass">
											<DataTable
												noHeader
												pagination
												columns={Inscolumns}
												data={groupInfo}
												progressPending={isLoading}
												paginationServer
												paginationPerPage={10}
												paginationTotalRows={groupTotalRows}
												paginationRowsPerPageOptions={[]}
												paginationDefaultPage={groupCurrentPage}
												onChangePage={(page) => {
													GetgroupInfo(jobAppId, page);
												}}
												sortIcon={<ChevronDown size={10} />} // Sorting icon
												className="react-dataTable" // Custom class for styling

											// noHeader
											// pagination
											// columns={columns}
											// data={Appliedjob}
											// progressPending={isLoading} // Show a loader when fetching data
											// paginationServer // Enable server-side pagination
											// paginationPerPage={10} // Number of rows per page
											// paginationTotalRows={totalRows} // Total rows for calculating pages
											// paginationRowsPerPageOptions={[]}
											// paginationDefaultPage={currentPage}
											// onChangePage={(page) => {
											// 	getAppliedJobList(page); // Update the current page
											// }}
											// sortIcon={<ChevronDown size={10} />} // Sorting icon
											// className="react-dataTable" // Custom class for styling
											/>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</Modal.Body>

			</Modal>
			{/*.................................... Group detail Modal End ................................*/}

			{/*.................................... Interview details Modal Start ................................*/}

			<Modal show={interviewDetailModal} onHide={handleCloseinterviewDetail} centered>
				<Modal.Header>
					<Modal.Title>Interview Details</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseinterviewDetail}
					/>
				</Modal.Header>
				<Modal.Body className="settings" style={{ maxHeight: "400px", overflowY: "auto" }}>
					{/* {interviewDetail && interviewDetail.length > 0 ? ( */}
					<div
						className="profile-resume-user-acvtivity "
					>

						<div className="  mb-3">

							{interviewDetail.scheduledInterviewInfo === null ? '' : (
								<>
									{/* <h6 className="f-600 mb-1"> <u>Interview Details</u> </h6> */}
									{interviewDetail.scheduledInterviewInfo?.placeDetails === "" ? '' : (
										<p className="f-14 f-400 mb-1">
											<span className="f-600">Location : </span>
											{interviewDetail?.scheduledInterviewInfo?.placeDetails}
										</p>
									)}
									{interviewDetail.scheduledInterviewInfo?.remark === "" ? '' : (
										<p className="f-14 f-400 mb-1">
											<span className="f-600">Remark : </span>
											{interviewDetail?.scheduledInterviewInfo?.remark}
										</p>
									)}
									{interviewDetail.scheduledInterviewInfo?.placeType === null ? "" : (
										<p className="f-14 f-400 mb-1">
											<span className="f-600">Place Type : </span>
											{interviewDetail?.scheduledInterviewInfo?.placeType}
										</p>
									)}
									{interviewDetail.scheduledInterviewInfo?.scheduleTime && (
										<div className="profile-resume-pdf-text f-14 f-500 d-conntents">
											<CalendarMonthSharpIcon className="me-1" /><span className="f-600 mt-2"> Date :</span> {moment
												.utc(interviewDetail?.scheduledInterviewInfo?.scheduleTime)
												.local()
												.format("DD MMM YYYY -- hh : mm A")}
										</div>
									)}
								</>

							)}
						</div>
					</div>
					{/* ) : (
						<p>No job history available.</p>
					)}  */}

				</Modal.Body>

			</Modal>
			{/*.................................... Interview details Modal End ................................*/}


			{/*....................................  Job detail Modal Start ................................*/}

			<Modal show={showJobDetailModal} onHide={handleCloseJobDetailModal} centered>
				<Modal.Header>
					<Modal.Title>Job Details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseJobDetailModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className="mb-3">
						{selectedJob?.title && (
							<p>
								<span className="f-600">Title: </span> {selectedJob.title}
							</p>
						)}
						{selectedJob?.cityName && (
							<p>
								<span className="f-600">City: </span> {selectedJob.cityName}
							</p>
						)}

						{selectedJob?.hiringStatusName && (
							<p>
								<span className="f-600">Status: </span> {selectedJob.hiringStatusName}
							</p>
						)}
						{selectedJob?.designationName && (
							<p>
								<span className="f-600">Designation: </span> {selectedJob.designationName}
							</p>
						)}
						{selectedJob?.compName && (
							<p>
								<span className="f-600">Company: </span> {selectedJob.compName}
							</p>
						)}
						{selectedJob?.shortDescription && (
							<p>
								<span className="f-600">Short Description: </span>
								{/* {selectedJob.shortDescription} */}
								<div className="pointer"
									dangerouslySetInnerHTML={{
										__html: linkifyContent(
											addTargetBlankToAnchors(selectedJob.shortDescription)
										)
									}}
								>
								</div>
							</p>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Link
						to={`/job/${selectedJob?.jobId}`}
						className="btn khojPrimaryBtn me-2"
					>
						View
					</Link>
				</Modal.Footer>
			</Modal>
			{/*....................................  Job details SModal End ................................*/}
			{/* ...............UnAuthorize modal............  */}
			{unAuthorizeError ? (
				<Modal show={unauthModal} centered>
					<Modal.Header>
						<Modal.Title>Unauthorize session expired</Modal.Title>
					</Modal.Header>
					<Modal.Body className="settings">
						<div className=" mb-3">
							<p>{unAuthorizeError}</p>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Link
							className="pointer"
							to="/Login"
							onClick={() => {
								localStorage.removeItem("token"); // Remove authentication token
								sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
								localStorage.removeItem("Module");
							}}
						>
							<button className="btn btn-danger ">Login</button>
						</Link>
						{/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

					</Modal.Footer>

				</Modal>
			) : (
				""
			)}
		</>
	);
}

export default AppliedSec;
